module.exports = __webpack_public_path__ + "fonts/helveticaneuecyr_roman.cd235502.otf";